import { render, staticRenderFns } from "./inventoryStock.vue?vue&type=template&id=20771460&scoped=true"
import script from "./inventoryStock.vue?vue&type=script&lang=js"
export * from "./inventoryStock.vue?vue&type=script&lang=js"
import style0 from "./inventoryStock.vue?vue&type=style&index=0&id=20771460&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20771460",
  null
  
)

export default component.exports